// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2Ypz0","notification":"styles_notification__2Ldtv"};